import Image from 'next/image';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

const SECTION_GRADIENT = 'linear-gradient(-90deg, #001E65 0%, #0A0B0F 100%)';
const EMPOWER_IMAGE = '/images/about-us/empower-person.webp';

const PARAGRAPHS = [
  'Udacity\u2019s proven playbook is globally scalable, addressing the widespread digital talent shortages that impact growth, productivity, and innovation. We collaborate with enterprises and highly motivated individuals to design a tailored talent transformation journey enabled by our Digital Competency Platform.',
  'Our exclusive content is co-created and continually refined with industry leaders. Each Udacity program is deeply focused\u2014eliminating guesswork in selecting the right course. Projects go far beyond step-by-step guides, cultivating the critical thinking required for workplace relevance. Expert mentors unblock learning with personalized support, and verify complete mastery of competencies.',
] as const;

export function EmpowerSection() {
  return (
    <Box as='section' py={{ base: 12, md: '6rem' }} style={{ backgroundImage: SECTION_GRADIENT }}>
      <Flex
        align='center'
        direction='column'
        gap={{ base: 10, md: '4rem' }}
        maxW='1056px'
        mx='auto'
        px={{ base: 4, md: 0 }}
      >
        <Heading
          as='h2'
          color='white'
          fontFamily='heading'
          fontSize={{ base: '2rem', md: '3.375rem' }}
          fontWeight={600}
          letterSpacing='-0.02em'
          lineHeight={1.1}
          maxW='880px'
          textAlign='center'
        >
          Driving outcomes that empower learners, organizations and nations
        </Heading>

        <Flex
          alignItems={{ base: 'stretch', md: 'center' }}
          bg='rgba(123,162,255,0.06)'
          border='1px solid rgba(255,255,255,0.56)'
          borderRadius='16px'
          direction={{ base: 'column', md: 'row' }}
          gap={{ base: 6, md: 8 }}
          overflow='hidden'
          p={6}
          width='full'
        >
          <Flex
            color='blue.100'
            direction='column'
            display={{ base: 'contents', md: 'flex' }}
            fontFamily='body'
            fontSize={{ base: '1rem', md: '1.125rem' }}
            gap={8}
            lineHeight={1.5}
            maxW={{ base: 'full', md: '532px' }}
            p={8}
          >
            {PARAGRAPHS.map((paragraph, index) => (
              <Text key={paragraph} as='p' order={{ base: index === 0 ? 1 : 3, md: 0 }}>
                {paragraph}
              </Text>
            ))}
          </Flex>

          <Box
            bg='white'
            borderRadius='8px'
            flex={1}
            minH={{ base: '316px', md: '30rem' }}
            order={{ base: 2, md: 0 }}
            overflow='hidden'
            position='relative'
          >
            <Box display={{ base: 'block', md: 'none' }} inset={0} position='absolute'>
              <Image
                alt=''
                quality={100}
                src={EMPOWER_IMAGE}
                style={{ objectFit: 'cover', objectPosition: 'top' }}
                fill
              />
            </Box>
            <Box display={{ base: 'none', md: 'block' }} inset={0} position='absolute'>
              <Image
                alt=''
                quality={100}
                src={EMPOWER_IMAGE}
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                fill
              />
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
}
